import { useEffect, useState } from "react";
import FlashingDot from "../FlashingDot";
import baccalaureat from '../../images/degrees/bac.png';
import licence from '../../images/degrees/licence.png';
import bachelor from '../../images/degrees/moncton.png';
import Showcase from "../Showcase";
import RedirectModal from "../RedirectModal";

const Degrees = ({ trackedObjects }) => {

  const [isDegreeModalOpen, setIsDegreeModalOpen] = useState(false);
  const [selectedSlide, setSelectedSlide] = useState(1);

  const [bacDegree, setBacDegree] = useState(null);
  const [bachelorDegree, setBachelorDegree] = useState(null);
  const [licenceDegree, setLicenceDegree] = useState(null);

  const [isRedirectModalOpen, setIsRedirectModalOpen] = useState(false);

  const showRedirectModal = () => {
    setIsRedirectModalOpen(true);
  };

  useEffect(() => {
    setBacDegree(trackedObjects.find(o => o.name === 'bac-frame'));
    setBachelorDegree(trackedObjects.find(o => o.name === 'bachelor-frame'));
    setLicenceDegree(trackedObjects.find(o => o.name === 'licence-frame'));
  }, [trackedObjects]);

  const showDegreeModal = (i) => {
    setSelectedSlide(i);
    setIsDegreeModalOpen(true);
  };

  return (
    <>
      <Showcase selectedSlide={selectedSlide} setIsModalOpen={setIsDegreeModalOpen} isModalOpen={isDegreeModalOpen} images={[baccalaureat, bachelor, licence]} width={800} />
      <RedirectModal isModalOpen={isRedirectModalOpen} setIsModalOpen={setIsRedirectModalOpen} link='https://formations.univ-larochelle.fr/master-informatique-ingenierie-donnees?lang=fr' />
      {bacDegree && <FlashingDot onClick={showDegreeModal} param={'0'} position={{ x: bacDegree.pos.x, y: bacDegree.pos.y }} tooltip={{placement:'bottom', color:'rgba(0,0,0,0.7)', title:'Baccalauréat'}} />}
      {bachelorDegree && <FlashingDot onClick={showDegreeModal} param={'1'} position={{ x: bachelorDegree.pos.x, y: bachelorDegree.pos.y }} tooltip={{placement:'bottom', color:'rgba(0,0,0,0.7)', title:'Bachelor'}} />}
      {licenceDegree && <FlashingDot onClick={showDegreeModal} param={'2'} position={{ x: licenceDegree.pos.x, y: licenceDegree.pos.y }} tooltip={{placement:'bottom', color:'rgba(0,0,0,0.7)', title:'Licence'}} />}
      {licenceDegree && bachelorDegree && <FlashingDot onClick={showRedirectModal} position={{ x: bachelorDegree.pos.x, y: licenceDegree.pos.y }} tooltip={{placement:'bottom', color:'rgba(0,0,0,0.7)', title:'Master'}} />}
    </>
  );
};

export default Degrees;